// iter-277 (Feb 2026) — Company TRN badge for invoices / receipts.
// Two variants:
//   1. Static:  <TrnBadge value="1000..." />
//        Shows the exact TRN the caller already has (e.g. an
//        immutable snapshot stored on a paid invoice at issuance).
//   2. Live:    <TrnBadge />
//        Fetches /api/admin/company-settings once and shows the
//        currently-active TRN pulled from the tax certificate.
// Renders nothing when there is no TRN available.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ShieldCheck } from 'lucide-react';
import { getAuthHeaders } from '../utils/authHeaders';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function TrnBadge({ value, language = 'ar', className = '', testId = 'trn-badge' }) {
  const [live, setLive] = useState('');

  useEffect(() => {
    if (value) return undefined;              // caller already has one
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${BACKEND_URL}/api/admin/company-settings`, {
          headers: getAuthHeaders(),
        });
        if (!cancelled) setLive(r.data?.company_info?.trn || '');
      } catch (_) { /* silent — badge just won't render */ }
    })();
    return () => { cancelled = true; };
  }, [value]);

  const trn = value || live;
  if (!trn) return null;

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-emerald-500/10 border border-emerald-500/30 ${className}`}
      dir="ltr"
      data-testid={testId}
    >
      <ShieldCheck className="h-3.5 w-3.5 text-emerald-400" />
      <span className="text-[10px] uppercase text-emerald-300/70 tracking-wider">
        TRN
      </span>
      <span className="font-mono tracking-wider text-emerald-200 text-sm">{trn}</span>
    </div>
  );
}

export default TrnBadge;
